module.exports = __webpack_public_path__ + "img/page2-four.692d6ee2.png";